import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

import {filter, finalize, switchMap, takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../../../destroyable.component';
import {Validators as GpValidators} from '../../../forms';
import {UserService} from '../../user.service';
import {Profile, SelectValue} from '../../../../+settings/user-rights/user-rights.interfaces';
import {sortBy} from 'lodash';

@Component({
  selector: 'gp-create-admin-user-modal',
  templateUrl: './create-admin-user-modal.component.html'
})
export class CreateAdminUserModalComponent extends Destroyable implements OnInit {

  private excludedProfiles = ['EMPLOYEE', 'FLO_EMPLOYEE', 'PRO_EMPLOYEE', 'MANAGER', 'FLO_MANAGER', 'PRO_MANAGER'];
  public createAdminUserForm: UntypedFormGroup;
  public loading = false;
  public isEmployee = false;
  public profileArray: SelectValue[] = [];

  constructor(private userService: UserService,
              private gpValidators: GpValidators,
              private formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.createAdminUserForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [GpValidators.emailValidator, Validators.required], this.isEmailExist.bind(this)],
      profileName: ['', Validators.required]
    });

    this.userService.getProfiles().pipe(
      tap((profiles: Profile[]) => {
        this.profileArray = profiles.filter((p: Profile) => !this.excludedProfiles.includes(p.name))
        .map((p: Profile) => ({
          id: p.name,
          text: p.transId
        }));
        this.profileArray = sortBy(this.profileArray, 'text');
      }),
      takeUntil(this.componentDestroyed$)
    ).subscribe();

    this.createAdminUserForm.get('email').valueChanges
      .pipe(
        filter((value) => !!value),
        switchMap((value) => this.userService.getNonEmpUserIdByEmail(value)),
        tap((userId: number) => {
          this.isEmployee = !userId;
        }),
        takeUntil(this.componentDestroyed$)
      ).subscribe();
  }

  public get profileNameFormControl() {
    return this.createAdminUserForm.get('profileName') as UntypedFormControl;
  }

  public isEmailExist(c: UntypedFormControl) {
    this.loading = true;

    return this.gpValidators.isEmailExistValidator(c, null)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      );
  }

  public onSubmit() {
    this.userService.updateCreatedAdminUser(this.createAdminUserForm.value);
  }
}
